import styled from "styled-components";

export const StyledVaultEmailsForm = styled.div`
  width: 100%;

  .emails {
    width: 100%;
  }
`;
